@let results = resultsCount();
@let count = filtersCount();

<!-- Desktop: the Smart Filter toolbar, or a plain row when there is nothing to open. -->
@if (hasToggle()) {
  <fr8bot-ui-smart-filter
    class="tw:block tw:filters-compact:hidden"
    [filtersCount]="count"
    [disablePanel]="!smart()"
    (clearFilters)="clearFilters.emit()"
  >
    @if (search(); as search) {
      <ng-container
        search
        [ngTemplateOutlet]="search.template"
        [ngTemplateOutletContext]="{ inDialog: false }"
      />
    }

    @if (quick(); as quick) {
      <ng-container
        search
        [ngTemplateOutlet]="quick.template"
        [ngTemplateOutletContext]="{ inDialog: false }"
      />
    }

    @if (results !== null) {
      <ng-container results>{{ results }} {{ 'common.filters.results' | translate }}</ng-container>
    }

    @if (settings(); as settings) {
      <ng-container table-settings [ngTemplateOutlet]="settings.template" />
    }

    @if (smartLabel(); as smartLabel) {
      <ng-container filters-label [ngTemplateOutlet]="smartLabel.template" />
    }

    @if (smart(); as smart) {
      <ng-container
        filters
        [ngTemplateOutlet]="smart.template"
        [ngTemplateOutletContext]="{ inDialog: false }"
      />
    }
  </fr8bot-ui-smart-filter>
} @else {
  <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-2.5 tw:filters-compact:hidden">
    @if (search(); as search) {
      <ng-container
        [ngTemplateOutlet]="search.template"
        [ngTemplateOutletContext]="{ inDialog: false }"
      />
    }

    @if (quick(); as quick) {
      <ng-container
        [ngTemplateOutlet]="quick.template"
        [ngTemplateOutletContext]="{ inDialog: false }"
      />
    }

    <!-- The search clears itself, so «Clear filters» is only for the quick filters next to it. -->
    @if (results !== null || (quick() && count > 0)) {
      <div class="tw:flex tw:h-10 tw:shrink-0 tw:items-center tw:gap-[15px] tw:whitespace-nowrap">
        <ng-container [ngTemplateOutlet]="resultsLabel" />

        @if (quick() && count > 0) {
          <ng-container [ngTemplateOutlet]="clearLink" />
        }
      </div>
    }

    @if (settings(); as settings) {
      <div class="tw:ml-auto tw:flex tw:items-center tw:gap-[5px]">
        <ng-container [ngTemplateOutlet]="settings.template" />
      </div>
    }
  </div>
}

<!-- From 1024px down: the search with the result count on its line, and one button below it
     that opens the rest in the dialog, where «Clear filters» is. The search clears itself. -->
<div class="list-filters-compact tw:hidden tw:flex-col tw:gap-2.5 tw:filters-compact:flex">
  @if (search(); as search) {
    <div class="tw:flex tw:items-center tw:gap-x-[15px]">
      <div
        class="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col"
        data-testid="list-filters-compact-search"
      >
        <ng-container
          [ngTemplateOutlet]="search.template"
          [ngTemplateOutletContext]="{ inDialog: true }"
        />
      </div>

      <ng-container [ngTemplateOutlet]="resultsLabel" />
    </div>
  } @else if (!hasDialog()) {
    <ng-container [ngTemplateOutlet]="resultsLabel" />
  }

  @if (hasDialog() && !buttonInHeader()) {
    <div class="tw:flex">
      <ng-container [ngTemplateOutlet]="headerButton" />
    </div>
  }
</div>

<!-- Rendered here or, through `PageHeaderActions`, in the page header. A phone keeps the icon. -->
<ng-template #headerButton>
  <button
    fr8botUiFiltersButton
    class="tw:max-[745px]:w-10 tw:max-[745px]:px-0"
    [count]="filtersCount()"
    [attr.aria-label]="'common.filters.title' | translate"
    data-testid="list-filters-open"
    (click)="openDialog()"
  >
    <span class="tw:max-[745px]:hidden">{{ 'common.filters.title' | translate }}</span>
  </button>
</ng-template>

<ng-template #resultsLabel>
  @if (results !== null) {
    <span
      class="typography-body-2 tw:flex tw:h-10 tw:shrink-0 tw:items-center tw:whitespace-nowrap tw:text-gray-3"
    >
      {{ results }} {{ 'common.filters.results' | translate }}
    </span>
  }
</ng-template>

<ng-template #clearLink>
  <button class="link" data-testid="list-filters-clear" (click)="clearFilters.emit()">
    <span class="tw:underline">{{ 'common.smartFilter.markup.clearFilters' | translate }}</span>
    <fr8bot-ui-icon name="x-1-12" [size]="12" />
  </button>
</ng-template>

<ng-template #dialog>
  <fr8bot-ui-filters-dialog
    [filtersCount]="filtersCount()"
    [resultsCount]="resultsCount()"
    (closeDialog)="closeDialog()"
    (clearFilters)="clearFilters.emit()"
  >
    @if (settings(); as settings) {
      <ng-container settings [ngTemplateOutlet]="settings.template" />
    }

    @if (quick(); as quick) {
      <ng-container
        search
        [ngTemplateOutlet]="quick.template"
        [ngTemplateOutletContext]="{ inDialog: true }"
      />
    }

    @if (smart(); as smart) {
      <div smart-filters class="tw:flex tw:flex-col tw:gap-[15px]">
        @if (smartLabel(); as smartLabel) {
          <div class="tw:flex">
            <ng-container [ngTemplateOutlet]="smartLabel.template" />
          </div>
        }

        <div class="tw:flex tw:flex-col tw:gap-2.5">
          <ng-container
            [ngTemplateOutlet]="smart.template"
            [ngTemplateOutletContext]="{ inDialog: true }"
          />
        </div>
      </div>
    }

    @for (filter of dialogFilters(); track filter.key()) {
      <div class="tw:flex tw:flex-col tw:gap-2">
        <span class="typography-labels-2 tw:text-gray-2" data-testid="filters-dialog-label">
          {{ filter.label() }}
        </span>

        <ng-container
          [ngTemplateOutlet]="filter.template"
          [ngTemplateOutletContext]="{ $implicit: filter.key(), inDialog: true }"
        />
      </div>
    }
  </fr8bot-ui-filters-dialog>
</ng-template>
